// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { Popover } from 'antd';
import React, { ReactElement, useState } from 'react';
import { SketchPicker } from 'react-color';

interface ColorPickerProps {
    defaultColor?: string;
    value?: string;
    onChange?: (value: string) => void;
    popover?: boolean;
}

const ColorPicker = ({ defaultColor, value, onChange, popover = false }: ColorPickerProps): ReactElement => {
    const [selfValue, setSelfValue] = useState(defaultColor || value);

    const handleChange = (value: string): void => {
        setSelfValue(value);
        onChange?.(value);
    };

    return popover ? (
        <Popover
            content={<SketchPicker color={value || selfValue} onChange={(color): void => handleChange(color.hex)} />}
        >
            <THButton icon={<ICONS.BgColorsOutlined />} />
        </Popover>
    ) : (
        <SketchPicker color={selfValue} onChange={(color): void => handleChange(color.hex)} />
    );
};

export default ColorPicker;
